import { useState } from "react";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../src/assets/images/header-white-logo.png";
import logoblack from "../../src/assets/images/header-black-logo.png";
import logout from "../../src/assets/images/logout.png";
const Header = ({ darkMode, setDarkMode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location?.pathname;
  const selectedService = location.state?.selectedService || null;

  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleLogout = () => {
    localStorage.removeItem("web-secret");
    navigate("/login");
  };

  return (
    <>
      <header>
        <Container>
          <Row className="align-items-center">
            <Col md={6} sm={2} xs={2}>
              <div className="d-flex gap-3 align-items-center">
                {pathname !== "/" && (
                  <button className="back_btn" onClick={() => navigate(-1)}>
                    <i className="fa-solid fa-arrow-left"></i>
                  </button>
                )}

                <div className="website_logo">
                  {" "}
                  <img className="dark_logo" src={logo} alt="" />{" "}
                  <img className="white_logo" src={logoblack} alt="" />
                </div>
              </div>
            </Col>
            <Col md={6} sm={10} xs={10} className="text-end">
              <div className="d-flex gap-3 align-items-center justify-content-end">
                {selectedService && (
                  <div className="selected_ai">{selectedService}</div>
                )}

                <button
                  className={`dark-toggle-btn ${darkMode ? "active" : ""}`}
                  onClick={() => setDarkMode(!darkMode)}
                  title={
                    darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"
                  }
                >
                  <i
                    className={`fa-solid ${darkMode ? "fa-moon" : "fa-sun"}`}
                  />
                </button>
                <button
                  className={`dark-toggle-btn`}
                  onClick={() => handleShow()}
                >
                  <i class="fa-solid fa-arrow-right-from-bracket"></i>
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="icon_circle">
       <img clas src={logout} alt=""/>
          </div> */}
          <h4 className="text-center"> Are you sure you want to logout?</h4>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button className="btn-gradient" onClick={handleClose}>
            No
          </button>
          <button className="btn-gradient" onClick={handleLogout}>
            Yes
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Header;
